var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import { connect } from "react-redux";
import RefreshsReduxProps from "../Refreshs/RefreshsReduxProps";
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: [],
            meta: null,
            refresh_message: null,
            buttonDisabled: false,
            selectedFile: '',
            message: '',
        };
        _this.onChangeHandler = function (event) {
            _this.setState({
                selectedFile: event.target.files[0]
            });
        };
        _this.submitForm = function () {
            var formData = new FormData();
            // Update the formData object
            formData.append("file", _this.state.selectedFile, 'file.csv');
            console.log(_this.state.selectedFile);
            _this.api.postPromocodeFile(formData)
                .then(function (response) {
                _this.setState({
                    buttonDisabled: true,
                    refresh_message: response.data.message
                });
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message + ' ' + err.response.data.errors[0],
                });
            });
        };
        _this.refreshButtonStatus = function () {
            _this.api.getRefreshButtonStatus()
                .then(function (response) {
                if (response.data.status === 'in_progress') {
                    _this.setState({ buttonDisabled: true });
                }
            }).catch(function (err) {
                _this.setState({
                    refresh_message: err.response.data.message,
                });
            });
        };
        return _this;
    }
    FileUpload.prototype.componentDidMount = function () {
        this.refreshButtonStatus();
    };
    FileUpload.prototype.render = function () {
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041A\u0430\u0447\u0438 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "" },
                            React.createElement("input", { type: "file", name: "file", onChange: this.onChangeHandler }),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement("button", { type: "button", disabled: this.state.buttonDisabled, className: "btn btn-sm btn-primary", onClick: this.submitForm },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u0417\u0430\u043F\u043E\u0447\u043D\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0430\u043D\u0435")),
                        React.createElement("div", null,
                            React.createElement("p", null, this.state.refresh_message)))))));
    };
    return FileUpload;
}(React.Component));
export default connect(null, RefreshsReduxProps.mapDispatchToProps)(FileUpload);



//////////////////
// WEBPACK FOOTER
// ./src/views/FileUpload/FileUpload.tsx
// module id = 350
// module chunks = 0